import {
  CardPicasso,
  Link,
  NavLink,
  Section,
  SectionHeader,
} from "@liberetech/design-system";
import classNames from "classnames";

import { useTranslation } from "lib/i18n/client";
import { destinationTravelGuidePath } from "lib/routes/paths";

import styles from "./DestinationSectionTravelGuide.module.css";

const DestinationSectionTravelGuide: React.FC<
  DestinationSectionTravelGuideProps
> = ({ title, posts, travelGuide, destination }) => {
  const { t } = useTranslation("destination");

  return (
    <Section background="secondary" id="travel-guide">
      <div className="grid">
        <SectionHeader
          label={title}
          title={t("travelGuide.title", { city: title })}
          centered
        />
        <ul className={classNames(styles.guideGrid, "grid")}>
          {posts.edges.length > 0 &&
            posts.edges.map(({ node: post }, i) => (
              <li key={i} className={styles.postItem}>
                <NavLink href={post.uri}>
                  <CardPicasso
                    title={post.title}
                    titleAs="h3"
                    image={
                      <img
                        srcSet={post.featuredImage.node.srcSet}
                        loading="lazy"
                        sizes="(min-width: 1024px) 50vw, 100vw"
                      />
                    }
                  />
                </NavLink>
              </li>
            ))}
          {posts.edges.length === 0 &&
            travelGuide.travelGuide &&
            travelGuide.travelGuide.map((guideBlock, i) => (
              <li key={i} className={styles.guideItem}>
                <CardPicasso
                  title={guideBlock.title}
                  titleAs="h3"
                  image={
                    <img
                      srcSet={guideBlock.image.srcSet}
                      loading="lazy"
                      sizes="(min-width: 1024px) 50vw, 100vw"
                    />
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: guideBlock.content,
                    }}
                  />
                </CardPicasso>
              </li>
            ))}
        </ul>
        {posts.edges.length > 0 && (
          <NavLink
            href={destinationTravelGuidePath(t, destination.uri)}
            className={styles.travelGuideShowAll}
          >
            <Link>{t("travelGuide.showAll")}</Link>
          </NavLink>
        )}
      </div>
    </Section>
  );
};

type DestinationSectionTravelGuideProps = {
  title: string;
  posts: {
    edges: Array<{
      node: {
        title: string;
        uri: string;
        featuredImage: {
          node: {
            srcSet: string;
          };
        };
      };
    }>;
  };
  travelGuide: {
    travelGuide: Array<{
      image: {
        srcSet: string;
      };
      title: string;
      content: string;
    }> | null;
  };
  destination: {
    uri: string;
  };
};

export default DestinationSectionTravelGuide;
